import { Col, List, Row } from "antd";
import React, { useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  BsChatLeftTextFill,
  BsFillTelephoneFill,
  BsTelephone,
} from "react-icons/bs";
import { GrMailOption } from "react-icons/gr";
import { IoIosShareAlt } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import personIcon from "../../../../assets/personIcon.png";
import {
  AntdTab,
  Box,
  ServiseProfileComponent,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import CopyLinkModal from "../../../../components/copyLinkModal/CopyLinkModal";
import { CalendarIcon, LocIcon } from "../../../../components/icons/Icons";
import Modal from "../../../../components/modal/Modal";
import PhoneNumberModal from "../../../../components/phoneNumberModal/PhoneNumberModal";
import AboutUs from "./AboutUs/AboutUs";
import CalendarComp from "./Calendar/Calendar";
import Documents from "./documents/Document";
import Photos from "./photos/Photos";
import Ratings from "./ratings/Ratings";
import Services from "./services/Services";
import styles from "./vendorDetails.module.css";
import { GoMail } from "react-icons/go";
import { IoMailOutline } from "react-icons/io5";
import addPerson from "../../../../assets/addPerson.svg";
import removePerson from "../../../../assets/removePerson.svg";
import { useDispatch, useSelector } from "react-redux";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";
import dummyImg from "../../../../assets/dummy.jpg";
import { phoneFormat } from "../../../../utills";
import moment from "moment";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { FaEdit } from "react-icons/fa";

const days = [
  { day: "Mon", avilable: true },
  { day: "Tue", avilable: false },
  { day: "Wed", avilable: true },
  { day: "Thu", avilable: false },
  { day: "Fri", avilable: true },
  { day: "Sat", avilable: false },
  { day: "Sun", avilable: true },
];

const AddPersonIcon = () => {
  return <img src={addPerson} />;
};
const RemovePerson = () => {
  return <img src={removePerson} />;
};

const VendorDetails = () => {
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [calendarModalOpen, setcalendarModalOpen] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [Details, setDetails] = useState({});

  const [loader, setloader] = useState(true);
  const role = Storage?.getERole("@role");
  // const EventDetails = useSelector((state) => state.EventReducer.EventDetails?.id);
  // const EventID = useSelector((state) => state.EventReducer.EventDetails?.id);

  const dispatch = useDispatch();
  const {
    state: { data: userData },
  } = useLocation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer.user);
  // console.log("state=======>>>>>>>", userData);
  // console.log("Details=======>>>>>>>", Details);
  const onChange = (key) => {
    console.log(key);
  };
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setloader(true);
    let data = {
      vendor_id: userData?.id,
      event_id: state?.eventData?.id ? state?.eventData?.id : null,
    };
    dispatch(VendorMiddleware.getVendorDetails(data))
      .then((res) => {
        setDetails(res);
        setloader(false);
      })
      .catch(() => {
        setloader(false);
      });
  };

  const addVendorToEvent = () => {
    let data = {
      vendor_id: userData?.id,
      event_id: state?.eventData?.id,
    };
    dispatch(VendorMiddleware.addToEvent(data))
      .then(() =>
        // dispatch(
        //   showAlert({ type: "Success", message: dtata })
        // ),
        navigate(-1)
      )
      .catch(() => {});
  };

  const removeVendorFromEvent = () => {
    let data = {
      vendor_id: userData?.id,
      event_id: state?.eventData?.id,
    };
    dispatch(VendorMiddleware.removeFromEvent(data))
      .then(() =>
        // dispatch(
        //   showAlert({
        //     type: "Success",
        //     message: "Vendor Removed Successfully",
        //   })
        // ),
        navigate(-1)
      )
      .catch(() => {});
  };
  const items = [
    {
      key: "1",
      label: "About Us",
      children: (
        <>
          <Row className={styles.tabContentCont}>
            <AboutUs details={Details} />
          </Row>
        </>
      ),
    },
    {
      key: "2",
      label: "Services",
      children: (
        <Row className={styles.tabContentCont}>
          <Services details={Details} />
        </Row>
      ),
    },
    {
      key: "3",
      label: "Rating",
      children: (
        <Row className={styles.tabContentCont}>
          <Ratings details={Details} />
        </Row>
      ),
    },
    {
      key: "4",
      label: "Photos",
      children: (
        <Row className={styles.tabContentCont}>
          <Photos details={Details} />
        </Row>
      ),
    },
    {
      key: "5",
      label: "Documents",
      children: (
        <Row className={styles.tabContentCont}>
          <Documents details={Details} />
        </Row>
      ),
    },
  ];

  console.log("user,Details", Details?.created_by);

  console.log("user,Details", user?.id);

  return (
    <>
      <ServiseProfileComponent
        image={Details?.image ? Details?.image : dummyImg}
      >
        <Col>
          <Row className={styles.contentCont}>
            <Col>
              <Row>
                <TextComponent text={Details?.name} textClass={styles.name} />
              </Row>
              <Row>
                <TextComponent
                  text={
                    Details?.service_category_name
                      ? Details?.service_category_name
                      : "Company"
                  }
                  textClass={styles.type}
                />
              </Row>
            </Col>
            <Col className={styles.iconsCont}>
            {Details?.created_by == user?.id && 
              <Box
                boxClass={styles.iconBox}
                onClick={() =>
                  navigate("/editSubVendor", {
                    state: { headrTitle: "Edit Staff", data: Details },
                  })
                }
              >
                <FaEdit size={17} className={styles.icon} />
              </Box>
              }
              <Box
                boxClass={styles.iconBox}
                onClick={() => {
                  setIsCopyModalOpen(true);
                }}
              >
                <IoIosShareAlt size={17} className={styles.icon} />
              </Box>
              <Box
                boxClass={styles.iconBox}
                onClick={() =>
                  navigate("/inbox", {
                    state: {
                      activeKey: role == roles.vendor ? "1" : "3",
                      chatData: Details,
                      screenType: "vendorDetailScreen",
                    },
                  })
                }
              >
                <BsChatLeftTextFill size={17} className={styles.icon} />
              </Box>
              <Box
                boxClass={styles.iconBox}
                onClick={() => {
                  setIsPhoneModalOpen(true);
                }}
              >
                <BsFillTelephoneFill size={17} className={styles.icon} />
              </Box>
            </Col>
          </Row>
          <Row
            style={{
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <Col className={styles.contentBox}>
              <Row className={styles.locCont}>
                <BsTelephone className={styles.locIcon} size={20} />
                <TextComponent
                  text={"Contact :"}
                  textClass={styles.DetailHead}
                />
                <TextComponent
                  text={phoneFormat(Details?.contact_no)}
                  textClass={styles.locText}
                />
              </Row>
              <Row className={styles.locCont}>
                <IoMailOutline className={styles.locIcon} size={20} />
                <TextComponent text={"Email :"} textClass={styles.DetailHead} />
                <TextComponent
                  text={Details?.email}
                  textClass={styles.locText}
                />
              </Row>
              {Details?.address && (
                <Row className={styles.locCont}>
                  <LocIcon className={styles.locIcon} size={20} />
                  <TextComponent
                    text={"Address :"}
                    textClass={styles.DetailHead}
                  />
                  <TextComponent
                    text={Details?.address}
                    textClass={styles.locText}
                  />
                </Row>
              )}
              {Details?.business_info?.start_time && (
                <Row
                  className={styles.locCont}
                  // style={{ cursor: "pointer" }}
                  // onClick={() => {
                  //   setcalendarModalOpen(true);
                  // }}
                >
                  <CalendarIcon size={20} className={styles.locIcon} />
                  <TextComponent
                    text={
                      Details?.business_info?.start_time &&
                      moment(Details?.business_info?.start_time).format(
                        "hh-mm a"
                      ) +
                        " to " +
                        moment(Details?.business_info?.end_time).format(
                          "hh-mm a"
                        )
                    }
                    textClass={styles.locTextBold}
                  />
                </Row>
              )}
            </Col>
            {/* {state?.eventData && ( */}
            {state?.eventData?.id &&
            (role == roles?.client || user.id == Details.created_by) ? (
              <Col className={styles.addVendorCont}>
                <SubmitButton
                  title={
                    Details?.is_already_joined
                      ? "Remove From Event"
                      : "Add To the Event"
                  }
                  rightIcon={
                    Details?.is_already_joined ? (
                      <RemovePerson />
                    ) : (
                      <AddPersonIcon />
                    )
                  }
                  btnClass={styles.addVendorBtn}
                  onClick={
                    Details?.is_already_joined
                      ? removeVendorFromEvent
                      : addVendorToEvent
                  }
                />
              </Col>
            ) : null}
            {/* {user.id == Details.created_by && state?.eventData?.id ? (
              <Col className={styles.addVendorCont}>
                <SubmitButton
                  title={
                    Details?.is_already_joined
                      ? "Remove From Event"
                      : "Assign To the Event"
                  }
                  rightIcon={
                    Details?.is_already_joined ? (
                      <RemovePerson />
                    ) : (
                      <AddPersonIcon />
                    )
                  }
                  btnClass={styles.addVendorBtn}
                  onClick={
                    Details?.is_already_joined
                      ? removeVendorFromEvent
                      : addVendorToEvent
                  }
                />
              </Col>
            ) : null} */}
            {/* )} */}
          </Row>
          <Row className={styles.daysMainCont}>
            {Details?.availability?.length == 0 ? null : (
              <Col className={styles.daysCol}>
                <Row className={styles.daysCont}>
                  {Details?.availability?.map((data) => (
                    <Col className={styles.dayCont}>
                      <TextComponent
                        text={data.day}
                        // textClass={`${styles.day} ${
                        //   !data.avilable && styles.noActiveDay
                        // }`}
                        textClass={styles.day}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
            )}
            {Details?.vendor_type != "individual" && (
              <Col className={styles.buttonCol}>
                <SubmitButton
                  leftIcon={<img src={personIcon} className={styles.subIcon} />}
                  btnClass={styles.btnClass}
                  title="Staff"
                  onClick={() =>
                    navigate("/findVendors/SubContacts", {
                      state: {
                        headrTitle: "Staff",
                        vendor_id: userData?.id,
                        event_id: state?.eventData?.id,
                        screenType: "vendorDetailScreen",
                      },
                    })
                  }
                />
              </Col>
            )}
          </Row>
        </Col>
      </ServiseProfileComponent>
      <AntdTab items={items} />
      <Modal
        isModalOpen={calendarModalOpen}
        setIsModalOpen={setcalendarModalOpen}
        closable={true}
        className={styles.modal}
      >
        <Row className={styles.modalCont}>
          <CalendarComp />
        </Row>
        <Row style={{ alignItems: "center" }}>
          <svg
            className={styles.clockIcon}
            viewBox="0 0 53 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.4521 0.410199C40.5566 0.436024 52.1518 12.057 52.1647 26.183C52.1776 40.4252 40.5695 52.0548 26.3316 52.0592C12.1195 52.0635 0.476985 40.3908 0.515721 26.1744C0.550154 11.9365 12.1798 0.384375 26.4521 0.410199ZM26.2886 31.3824C28.574 31.4039 30.9671 29.9534 31.1479 27.6679C31.3588 25.0166 33.0546 23.6781 34.6213 22.0898C36.8809 19.7958 39.1793 17.5318 41.4475 15.2464C43.2682 13.4128 43.5178 12.0915 42.2954 10.8304C41.0602 9.55206 39.6484 9.76296 37.8665 11.5362C35.3271 14.0584 32.8006 16.5935 30.2698 19.1286C27.3 22.1028 25.4191 22.1114 22.4751 19.1717C21.511 18.2119 20.5555 17.2435 19.5828 16.2923C18.3303 15.0613 16.9229 14.7471 15.6273 16.0814C14.4179 17.3338 14.7149 18.6896 15.8856 19.8732C17.0907 21.0956 18.283 22.3395 19.5311 23.5188C20.5383 24.47 21.2097 25.4083 21.2958 26.9621C21.4379 29.4713 23.8008 31.3608 26.2886 31.3824Z"
              fill="#EF62BD"
            />
          </svg>
          {/* <ClockIcon width={20} height={20} /> */}
          <TextComponent
            text={"02-00 am to 05-00 am"}
            textClass={styles.type}
          />
        </Row>
      </Modal>

      <CopyLinkModal
        isCopyModalOpen={isCopyModalOpen}
        setIsCopyModalOpen={setIsCopyModalOpen}
        link="https://bestdayever-web.web.app"
      />
      <PhoneNumberModal
        isPhoneModalOpen={isPhoneModalOpen}
        setIsPhoneModalOpen={setIsPhoneModalOpen}
        phoneNumber={phoneFormat(Details?.contact_no)}
      />
    </>
  );
};

export default VendorDetails;
